export const estateStatusKeys = {
  base: ['estateStatus'],
  householdSettings: (householdID: string | undefined | null) => [
    ...estateStatusKeys.base,
    'householdSettings',
    householdID,
  ],
  readOnlyHouseholdSettings: (householdID: string | undefined | null) => [
    ...estateStatusKeys.base,
    'readOnlyHouseholdSettings',
    householdID,
  ],
  firmTemplate: (firmID: string | undefined | null) => [...estateStatusKeys.base, 'firmTemplate', firmID],
};
